import axios from 'axios';

const baseUrl = process.env.REACT_APP_D3X_SERVICE_URL!;

type StatsType = {
  addressCount: number;
  d3xTotalVolume: string;
  d3xTradeCount: number;
  aTotalVolume: string;
  aTradeCount: number;
};
const statsUrl = baseUrl + '/stats/trade';
export const fetchStats = async () => {
  const result = await axios.get<StatsType>(statsUrl);
  return result.data;
};
